import { apiRequest } from './client'

export interface HomeInsightCard {
  id: string
  kind: 'action' | 'ai'
  eyebrow: string
  title: string
  body: string
  href: string
  variant?: 'heads_up' | 'pattern' | 'policy'
  cta?: string
  generatedAt?: string
  sourceRefs?: string[]
  /** Short markdown explanation for the receipt's "Why this?" popover.
   *  One Rule / Threshold / Trigger / Source line each. */
  why?: string
  metric?: string
  primary?: boolean
}

export interface HomeInsightsResponse {
  cards: HomeInsightCard[]
  generatedAt: string
}

export function getHomeInsights(): Promise<HomeInsightsResponse> {
  return apiRequest<HomeInsightsResponse>('/api/v1/home/insights')
}

export function dismissHomeInsight(id: string): Promise<null> {
  return apiRequest<null>(
    `/api/v1/home/insights/${encodeURIComponent(id)}/dismiss`,
    { method: 'POST' },
  )
}
